<svg xmlns="http://www.w3.org/2000/svg" width="140" height="88" viewBox="0 0 140 88" fill="none">
    <rect x="0.5" y="0.5" width="139" height="87" rx="3.5" fill="currentColor" stroke="#BBBFC3"/>
</svg>